<template>
  <v-container class="mt-10">
    <v-row>
      <v-col>
        <v-card class="mx-auto" max-width="600">
          <v-card-title>Entre com o email cadastrado no evento</v-card-title>
          <v-card-text>
            <v-form @submit.prevent="login" ref="form" v-model="valid" :lazy-validation="lazy">
              <v-text-field v-model="email" :rules="emailRules" label="Email" required></v-text-field>
            </v-form>
            <v-btn @click="login" color="primary" class="my-2">Entrar</v-btn>
            <p v-if="feedback" class="red--text my-2">{{ feedback }}</p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import firebaseApp from '@/firebase/init'

export default {
  name: 'Login',
  data () {
    return {
      email: null,
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid'
      ],
      valid: false,
      feedback: null,
      lazy: true
    }
  },
  methods: {
    login () {
      if (this.$refs.form.validate()) {
        this.feedback = null
        firebaseApp.auth().signInWithEmailAndPassword(this.email, '#teamtraining888').then(credential => {
          this.$router.push({ name: 'MyTrainings' })
        }).catch(() => {
          this.feedback = 'Por favor entre com o email cadastrado no evento.'
        })
      }
    }
  }
}
</script>
